import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach Bearer token (fallback when cookies blocked by CORS preflight)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function saveToken(t) {
  if (t) localStorage.setItem("session_token", t);
}
export function clearToken() {
  localStorage.removeItem("session_token");
}

export { API, BACKEND };
export default api;
